/**
 * Created by intellicar-rinas on 14/7/17.
 */
import React, {Component} from "react";
import "./InMap.css";
import Map from "./Map/Map"
import MQTT from './MQTT/MQTT';
import {MQTT_HOST, schemaTypes, dateFormat, dateFormatWithSec} from '../../constants/constants';
import {connect} from 'react-redux';
import actions from '../../store/actions';
import CallbackBuddy from '../CallbackBuddy/CallbackBuddy';
import searchConfig from '../../Layouts/config/searchConfig';
import {trackTime} from '../../helpers/debugger';
import InfoWindow from './InfoWindow/InfoWindow'
import InPopup from '../InPopup/InPopup';
import Dom from '../../helpers/Dom';
import CommandAPIs from '../../APIs/CommandAPIs';
// import InGraph from '../ReportWindow/schema/InGraph/InGraph';
import ForwardedInGraph from '../ReportWindow/schema/InGraph/InGraph';

import _ from 'lodash';
import CustomOverlay from './Map/CustomOverlay/CustomOverlay';
import InTable from '../ReportWindow/schema/InTable/InTable';
import MQTTKeyMap from '../../Layouts/config/MQTT/MQTTKeyMapConfig';
import moment from 'moment';
import $ from 'jquery';
import InVoice from '../InVoice/InVoice';
import stationmarker from './Map/Markers/railway_station_icon.png';
import expMarker from './Map/Markers/exp.svg'
import GeoCodeAPIs from '../../APIs/GeoCodeAPIs'
import UserAPIs from "../../APIs/UserAPIs";
import SharePopup from "../SharePopup/SharePopup";

/**
 * debug helper
 * tap into real time gps data
 * specify keys to filter out
 * eg. window.rtSubKey = ['od']
 * you can also tap into vehicle meta, prefix with 'vm'
 * eg. window.rtSubKey = ['od', 'vm.odofrom']
 */

let unprocessedData = {};
let stats = {};
let localRoadStats = {};
let localStatsFilter = {};
let deepFreeze = false;
let debugStats = false;
let tableViewChangedCalled = false;
let updateStatsCalled = false;


const fuelColor = (item) => {
    if(item.fuel >= 40) return '#2ab481'; // green
    if(item.fuel < 40 && item.fuel > 15) return '#fd6428'; // orange
    if(item.fuel <= 15) return '#da2f31'; // red
    return '#555';
}

let alarm_sound = require('../../assets/sounds/alarm.wav');
class InMap extends Component{

    state = {
        permission: null,
        multiSearchConditions: [],
        shareLink: false,
    };

    multiSearchConditions = [];

    constructor(props) {
        super(props);

        window.InMapForceUpdate=()=>this.forceUpdate();
        this.graphHandlerRef = React.createRef();
        this.mqttRef = null;
        
        // Preloaded audio instance to avoid repeated network requests
        this.preloadedAlarmAudio = null;
        this.alarmAudioPreloadAttempted = false;

        ['onReceivedMessage', 'onGPS', 'gotVehicleMap', 'updateStats', 'checkRoaded', 'isShowable', 'isAllowed', 'isVisible',
            'roadStatsChanged', 'reportWindowChanged', 'deepFreezeMode', 'getMapListeners', 'zoomChanged', 'onMESSAGE',
            'statsFilterChanged', 'singleSearch', 'isSearchStrMatch', 'updateVehicle', 'fitBounds',
            'getVisibleVehicles', 'tilesLoaded', 'isVehicleInBounds', 'drawPolygonOnMap', 'initInfoWindow', 'openDial',
            'closeDial', 'MQTTLoaded', 'onKLE', 'infoWindowEvents', 'onImmobWindowClose', 'canIImmobilize',
            'onPermUpdate', 'immobilize', 'openImmobilizeWindow', 'onImmobCWindowClose', 'onLockWindowClose', 'lock', 'honk',
            'geofenceChanged', 'isGeofenceVisible', 'updateGeofence', 'geofenceFiltersChanged', 'overlayFiltersChanged',
            'updateOverlay', 'overlayShow', 'onUserGPS', 'setBoundsOfSearchResults', 'turnOffAllOverlays', 'getGeofenceStyle',
            'triggerSingleSearch', 'evaluateString', 'isMultiSearchValid', 'isMultiSearchConditionValid', 'isTableViewActive'
        ]
            .map(item=> this[item] = this[item].bind(this));

        window.forceUpdateVehicle = this.forceUpdateVehicle =(vehicle)=> {
            vehicle.onroad = this.checkRoaded(vehicle.vehiclemeta);
            vehicle.showable = this.isShowable(vehicle,  this.props.roadStats);
            vehicle.searchStrMatch = this.isSearchStrMatch(vehicle,  this.searchStr);
            vehicle.markerVisible = this.isVisible(vehicle);
            return vehicle.markerVisible;
        };

        window.triggerSingleSearch = (timeout) =>{
            if (!timeout) {
                timeout = 500
            }
            setTimeout(this.triggerSingleSearch, timeout);
        };

        window.selectedLatLng = { lat: null, lng:null}
        localRoadStats = {...props.roadStats};

        window.openDial = false
        const getTableViewIgnitionIcon =(val, row, head)=> {
            return row.ignitionstatus ? ' fa-power-off -green -inverse' : ' fa-power-off -grey';
        };

        this.saveTableViewState =()=> {};
        this.getTableViewKey =()=> {
            return 'InMapTableView';
        };
        this.getTableViewResumeData =(config)=> {};
        this.getTableViewConfig =()=> {
            // #tableview
            return {
                key:'dataTable',
                type: schemaTypes.IN_TABLE,
                position:{ width:12, height:12, left:0, top:0},
                head:[
                    {key:'vehicleno', name:'Vehicle No', width: 2},
                    {key:'deviceno', name:'Device No', width: 2.5},
                    {key:'ign', name:'Ignition', width: 0.5, getIcon:getTableViewIgnitionIcon},
                    {key:'model', name:'Model', width: 1.5},
                    {key: 'variant', name: "Variant", width:2},
                    {key:'lasttalktime', name:'Last Talk Time', type:'DATE', format:dateFormat, width: 1.5},
                    {key:'speed', name:'Speed', width: 1},
                    // {key:'fuel', name:'Fuel', width: 1, color: fuelColor},
                    {key:'fuelVal', name:'Fuel', width: 1, color: fuelColor},
                    // {key:'address', name:'Address', width: 8},
                    {key:'latLng', name:'Address', width: 7, 
                    onClick: (d, item) => {
                      window.showInGoogleMaps(item.lat, item.lng);
                    },},
                    {key:'status', name:'Status', width: 2},
                ],
                _position: {
                    position:'relative',
                    height: window.innerHeight - 50,
                    width: window.innerWidth - 50,
                    top: 0,
                    left: 0
                }
            }
        };

        const getVehicleStatus =vehicle=> {
            for(let idx in vehicle.filters) {
                if(vehicle.filters[idx] !== 'allvehicles') {
                    return vehicle.filters[idx];
                }
            }
            return 'Unknown'
        };

        const processTableData =()=> {
            let data = [];
            let vmap = this.getVehicleMap();
            for(let idx in vmap) {
                if(vmap[idx].type === 'vehicle' && vmap[idx].stats) {
                    let fuelPerc = _.get(vmap[idx], 'stats.fuel', 0);
                    let fuelCapacity = _.get(vmap[idx], 'fueltankcapacity', 0);
                    let isGas = ['P', 'D'].includes(vmap[idx].vehiclemeta.fueltype);
                    let fuelVal = (fuelCapacity * fuelPerc / 100);
                    if(fuelVal % 1 !== 0) fuelVal = fuelVal.toFixed(1);
                    // #dataTable, tableView
                    data.push({
                        vehicleno:vmap[idx].vehicleno,
                        model:vmap[idx].vehiclemeta.model,
                        lasttalktime:vmap[idx].stats.utctime,
                        speed:vmap[idx].stats.speed,
                        address:vmap[idx].stats.address,
                        latLng:`(${vmap[idx].stats.lat},${vmap[idx].stats.lng})`,
                        lat:vmap[idx].stats.lat,
                        lng:vmap[idx].stats.lng,
                        ignitionstatus:vmap[idx].stats.ignitionstatus,
                        status:getVehicleStatus(vmap[idx]),
                        deviceno:vmap[idx].devices.TRACKER.deviceno,
                        fuel:fuelPerc,
                        fuelVal: fuelVal + (isGas ? ' ltr' : ''),
                        variant: vmap[idx].vehiclemeta.variant,
                    });
                }
            }
            return data;
        };

        this.updateTableView =()=> {
            if(this.props.tableView.active) {
                let processedData = processTableData();
                if(this.refs.tableView && 'setData' in this.refs.tableView) {
                    this.refs.tableView.setData(processedData);
                }
            }
            tableViewChangedCalled = false
        };

        this.tableViewChanged =(data)=> {
            // console.log("tableViewChanged")
            // setTimeout(this.updateTableView, 500);

            if(!tableViewChangedCalled) {
                tableViewChangedCalled = true
                setTimeout(this.updateTableView, 200);
            }
        };

        // $(window).focus(()=> {
        //     // Do Focus Actions Here
        //     console.log('Force Refreshing Vehicles');
        //     this.updateStats(this.getVehicleMap(), true, false);
        // });

        setTimeout(()=>{
            window.location.reload();
        }, 1000 * 60 * 60 * 24);

        window.onInMapGPS = this.onGPS;

    }

    componentDidMount() {
        // this.initInfoWindow();
          setTimeout(() => {
            if (this.graphHandlerRef.current) {
              this.initInfoWindow();
            } else {
            }
          }, 1000);
        window.addEventListener('keydown', e=>{
            if(e.ctrlKey && e.shiftKey && e.keyCode === 75) {
                debugStats = !debugStats;
                console.log('Debug Stats: ', debugStats ? 'ON': 'OFF')
            }

            // double r opens report window
            if(e.keyCode === 82 && e.target.tagName != 'INPUT') {
                if(this.rKeyPressed && !this.props.reportWindow.visible) {
                    this.props.dispatch({ type:actions.TOGGLE_REPORT_WINDOW });
                    delete this.rKeyPressed;
                } else {
                    this.rKeyPressed = moment().valueOf();
                    setTimeout(() => delete this.rKeyPressed, 1000);
                }
            }
        });

        window.showAlerts = this.showAlerts;
        // this.startMarkerDataCorrector(3000);
        setTimeout(() =>{ this.setPoi() }, 1000);
        
        // Preload alarm audio after component mounts (non-blocking, delayed to not affect initial render)
        setTimeout(() => {
            this.preloadAlarmAudio();
        }, 2000);

    }

    // Preload alarm audio once to avoid repeated network requests in production
    preloadAlarmAudio = () => {
        if (this.alarmAudioPreloadAttempted) {
            return; // Already attempted preload
        }
        
        this.alarmAudioPreloadAttempted = true;
        
        try {
            this.preloadedAlarmAudio = new Audio(alarm_sound);
            this.preloadedAlarmAudio.preload = 'auto';
            // Preload in background (non-blocking)
            this.preloadedAlarmAudio.load().catch(err => {
                // Silently handle preload failure - will fallback to creating new Audio when needed
                console.debug("Alarm audio preload failed (will use fallback):", err);
            });
        } catch (error) {
            // Silently handle creation failure - will fallback to creating new Audio when needed
            console.debug("Failed to create preloaded alarm audio (will use fallback):", error);
        }
    };

    // Get a playable audio instance - reuses preloaded one if available
    getAlarmAudioInstance = () => {
        // If preloaded audio exists and is ready, create a new instance with same source (browser will use cached file)
        if (this.preloadedAlarmAudio) {
            try {
                // Create new Audio with same source - browser will use cached file from preload
                return new Audio(alarm_sound);
            } catch (error) {
                console.debug("Failed to create audio from preloaded source:", error);
            }
        }
        
        // Fallback: create new Audio (will trigger network request, but this is rare if preload worked)
        try {
            return new Audio(alarm_sound);
        } catch (error) {
            console.debug("Failed to create alarm audio instance:", error);
            return null;
        }
    };

    startMarkerDataCorrector =interval=> {
        clearInterval(this.markerDataCorrectorInterval)
        this.markerDataCorrectorInterval = setInterval(this.verifyMarkerPosition, interval);
    }

    verifyMarkerPosition =()=> {
        let vehicles = this.getVisibleVehicles().visible;
        let markerPos;
        let actPos;
        let mismatch = [];
        for(let idx in vehicles) {
            if(!vehicles[idx].marker)
                continue;

            actPos = {lat: vehicles[idx].stats.lat, lng: vehicles[idx].stats.lng}
            markerPos = vehicles[idx].marker.getPosition();
            if(actPos.lat != markerPos.lat().toFixed(6) || actPos.lng != markerPos.lng().toFixed(6)) {
                mismatch.push(vehicles[idx]);
            }
        }


        if(mismatch.length) {
            console.error('Arhh, There you go', mismatch)
        } else {
            console.log('Perfect! No mismatch so far.');
        }
    }

    onUserGPS(msg) {
        console.log(msg);
    };

    onReceivedMessage(event){
        switch (event.type){
            case "GPS":
                // this.onGPS(event.data, event.type);
                break;

            case "CAN":
                this.onMESSAGE(event.data,'CAN');
                break;

            case "CAN2":
                this.onMESSAGE(event.data, 'CAN2');
                break;

            case "TPMS":
                this.onMESSAGE(event.data, 'TPMS');
                break;

            case "DTC":
                this.onMESSAGE(event.data, 'DTC');
                break;

            case "KLE":
                this.onKLE(event.data);
                break;

            case "PHONEINFO":
                console.log(event.data)
                this.onMESSAGE(event.data, 'PHONEINFO');
                break;

            case "USERGPS":
                this.onGPS(event.data, event.type);
                break;

            case "GOT_ALL_BUCKETS":
                window.gotAllBuckets = true
                let invalidLatLng = [];
                let neverCommunicated = [];
                let vmap = this.getVehicleMap();
                for(let idx in vmap) {
                    if (vmap[idx].TRACKER_deviceno && vmap[idx].TRACKER_deviceno.length) {
                        if (!vmap[idx].marker && !vmap[idx].invalidLatLng && idx.indexOf('user') === -1) {
                            neverCommunicated.push(vmap[idx]);
                        } else if (vmap[idx].invalidLatLng && idx.indexOf('user') === -1) {
                            invalidLatLng.push(vmap[idx]);
                        }
                    }
                }
                // console.log('Vehicles Never Communicated, Count =', neverCommunicated.length,  neverCommunicated);
                // console.log('Vehicles With Invalid LatLng, Count =', invalidLatLng.length, invalidLatLng);
                break;

            default:
        }
    }

    isGeofenceVisible (params) {
        return params && this.props.geofenceFilters.data[params.type];
    }

    updateGeofence() {
        if(!this.geofences)
            return;

        for(let idx in this.geofences.data) {
            if(this.geofences.data[idx].polygon) {
                this.geofences.data[idx].polygon.setVisible(this.isGeofenceVisible(this.geofences.data[idx].info));
            }
        }
    }

    geofenceColorMap = {
        parking:{
            fill:'#33c922',
            strokeColor:'#33c922',
            stroke:3,
        },
        servicestation:{
            fill:'#bc31ff',
            strokeColor:'#bc31ff',
            stroke:3,
        },
        competitor:{
            fill:'#f31d33',
            strokeColor:'#f31d33',
            stroke:3,
        },
        citylimit:{
            fill:'#4877ff',
            strokeColor:'#4877ff',
            stroke:1,
        },
        tollplaza:{
            fill:'#f37813',
            strokeColor:'#f37813',
            stroke:3,
        },
    }

    getGeofenceStyle =data=> {
        return this.geofenceColorMap[data.type] || {}
    };

    drawPolygonOnMap = (data) => {

        const drawPolygon = (params) => {
            if(!window.google || !params || !params.coords) return;
            return new window.google.maps.Polygon({
                paths: params.coords.map(d=>{return{lat:parseFloat(d.lat), lng:parseFloat(d.lng)}}),
                strokeColor: '#4e9fff',
                strokeOpacity: 0.8,
                strokeWeight: 2,
                fillColor: '#72b3ff',
                fillOpacity: 0.35,
                visible:this.isGeofenceVisible(params),
                ...this.getGeofenceStyle(params)
                // draggable : true,
                // editable: true,
            });
        };

        const drawCircle = (params) => {
            if(!window.google || !params || !params.radius) return;
            return new window.google.maps.Circle({
                strokeColor: '#4e9fff',
                strokeOpacity: 0.8,
                strokeWeight: 2,
                fillColor:'#72b3ff',
                fillOpacity: 0.35,
                center: params.center,
                radius: parseInt(params.radius, 10),
                ...this.getGeofenceStyle(params),
                visible:this.isGeofenceVisible(params)
                // draggable : true,
                // editable: true,
            });
        };

        if(data.polygon && data.polygon.setMap){
            data.polygon.setMap(null);
        }
        if(data.info.structure === 'circle') {
            data.polygon = drawCircle(data.info)
        } else {
            data.polygon = drawPolygon(data.info);
        }
        if(data.polygon) {
            data.polygon.addListener('click', ()=>{
                this.props.dispatch({
                    type:actions.ADD_INTOAST,
                    data:{
                        name:data.name,
                        content:'Type : ' + data.info.type,
                        replace:true,
                        createAt:Date.now()
                    }
                });
                window.changeLeftTreeTab(3, data.id);
            });
            data.polygon.setMap(window.map);
        }
        if(window.auth.userinfo.username == 'irctc' && data.info.type == 'trainstation'){
            this.drawRailwayMarkers(data);
        }
        return data;

    };

    lastTableUpdate = 0

    onGPS(msg, source = 'GPS'){
        let vmap = this.getVehicleMap();
        if(vmap){
            // loop through vehicles
            for(let idx in msg){
                let m = msg[idx];
                if(msg[idx].vp in vmap){
                    if(this.selectedVehicle && msg[idx].vp === this.selectedVehicle.vehicleid) {
                        //console.log('GPS', msg[idx]);
                    }
                    vmap[msg[idx].vp].gpsRaw = msg[idx];
                    this.processMarker(vmap[msg[idx].vp], msg[idx], source)
                }
                // debug helper
                if(Array.isArray(window.rtSubKey) && window.rtSubKey.length > 0) {
                    let vSubMsg = {id: m.vp}
                     window.rtSubKey.forEach(k => {
                        if(k.indexOf('vm') === 0) vSubMsg[k] = _.get(window.vehicleMap, m.vp + '.vehiclemeta' + k.slice(2));
                        else vSubMsg[k] = _.get(m, k);
                    })
                    console.log(vSubMsg);
                }
                // another debug helper, tap at vehicle level eg. GPS                
                if(window.subVehicleId) {
                    if(msg[idx].vp === window.subVehicleId) {
                        console.log(source, msg[idx]);
                    }
                }
            }
            this.updateStats(msg, true, true);
            // throttle table updates
            const now = new Date().valueOf();
            if(now > this.lastTableUpdate + 1000) {
                this.updateTableView(msg);
                this.lastTableUpdate = now;
            }
            if(window.gotAllBuckets)this.showAlerts(msg);
            if(this.selectedVehicle && msg.filter(item=>{return item.vp === this.selectedVehicle.vehicleid}).length) {
                this.infoWindow.update(this.selectedVehicle);
            } 
        }else{
            if(!unprocessedData[source]) {
                unprocessedData[source] = []
            }
            unprocessedData[source].push(...msg);
        }
    }


    onKLE(msg) {
        let vehicle = this.getVehicleMap()[msg.vp];
        if(!vehicle.stats) return;

        vehicle.stats.kletime = msg.kts;
        console.log(msg, 'KLE');
        // this.infoWindow.update(vehicle.stats);
        this.infoWindow.update(vehicle);
        // console.log('KLE', msg);
    }

    onMESSAGE(msg, configKey) {
        //console.log(configKey, msg);
        let vehicle = this.getVehicleMap()[msg.vp || ('user_'+msg.ui)];
        let val;
        let key;
        if(!vehicle || !vehicle.stats) return;

        vehicle[configKey] = msg;

        for(let idx in MQTTKeyMap[configKey]) {
            key = MQTTKeyMap[configKey][idx].from;
            val = msg[key];
            if(MQTTKeyMap[configKey][idx].processData) {
                if(typeof MQTTKeyMap[configKey][idx].processData !== 'function') {
                    for(let jdx in MQTTKeyMap[configKey][idx].processData) {
                        val = MQTTKeyMap[configKey][idx].processData[jdx](val, msg, vehicle, MQTTKeyMap[configKey][idx].key, MQTTKeyMap[configKey][idx]);
                    }
                } else {
                    val = MQTTKeyMap[configKey][idx].processData(val, msg, vehicle, MQTTKeyMap[configKey][idx].key, MQTTKeyMap[configKey][idx]);
                }
            }
            const config = MQTTKeyMap[configKey][idx];
            const conditionPasses = config.condition ? config.condition(val, msg, vehicle, key) : true;
            const nullCheckPasses = config.updateOnlyIfValid ? val !== null : true;
            if(conditionPasses && nullCheckPasses && val !== undefined) {
                const targetKey = config.key;
                vehicle.stats[targetKey] = val;
            }
        }

        this.infoWindow.update(vehicle);
        if (vehicle && vehicle.GPS){
            // console.log("calling add api")
            if (vehicle.GPS.lt && vehicle.GPS.ln){
                let payload = {
                    data: this.props.lastLoc && this.props.lastLoc.active === true ? [[vehicle.GPS.vlt, vehicle.GPS.vln]] : [[vehicle.GPS.lt, vehicle.GPS.ln]],
                    token: window.getAuth().token
                }
                GeoCodeAPIs.getMapAddress(payload).then((resp) => {
                    if(resp && resp[0]){
                        this.props.dispatch({
                            type: actions.ADD_INTOAST_LOCATION,
                            data: {
                                name: vehicle.vehicleno + (this.props.lastLoc && this.props.lastLoc.active === true ? ' - (' + vehicle.GPS.vlt + ',' + vehicle.GPS.vln + ')' : ' - (' + vehicle.GPS.lt + ',' + vehicle.GPS.ln + ')'),
                                content: resp[0].address,
                                replace: true,
                                createAt: Date.now(),
                                onceIWasNew: true,
                                viewInMap : true,
                                lat : this.selectedVehicle.stats.lat,
                                lng : this.selectedVehicle.stats.lng,
                            }
                        });
                    }
                }, (err) => {
                    this.props.dispatch({
                        type: actions.ADD_INTOAST_LOCATION,
                        data: {
                            name: vehicle.vehicleno + (this.props.lastLoc && this.props.lastLoc.active === true ? ' - (' + vehicle.GPS.vlt + ',' + vehicle.GPS.vln + ')' : ' - (' + vehicle.GPS.lt + ',' + vehicle.GPS.ln + ')'),
                            content: vehicle.GPS.add,
                            replace: true,
                            createAt: Date.now(),
                            onceIWasNew: true,
                            viewInMap : true,
                            lat : this.selectedVehicle.stats.lat,
                            lng : this.selectedVehicle.stats.lng,
                        }
                    });

                }) 
         }
     }
    }



    gotVehicleMap(){
        for(let source in unprocessedData) {
            for(let idx in unprocessedData[source]){
                if(unprocessedData[source][idx].vp in this.getVehicleMap()){
                    this.processMarker(this.getVehicleMap()[unprocessedData[source][idx].vp], unprocessedData[source][idx])
                }
            }
            this.updateStats(unprocessedData[source]);
            unprocessedData[source] = [];
        }
    }


    processMarker(vehicle, data, source='GPS'){

        /*
         *    Validating data
         * */
        if((data.lt < 3 && data.lt > -3 ) || (data.ln < 3 && data.ln > -3)) {
            vehicle.invalidLatLng = true;
            // console.warn('Vehicle With Invalid LatLng ', vehicle);
            // return;
        }

        /*
         *   Setting up vehicle stats
         * */
        if(!vehicle.stats){
            vehicle.stats = {};
        }

        let key;

        vehicle[source] = data;
        for(let idx in MQTTKeyMap[source]) {
            key = MQTTKeyMap[source][idx].from;
            let val = data[key];

            if(typeof MQTTKeyMap[source][idx].processData !== 'function') {
                for(let jdx in MQTTKeyMap[source][idx].processData) {
                    val = MQTTKeyMap[source][idx].processData[jdx](val, data, vehicle, MQTTKeyMap[source][idx].key, MQTTKeyMap[source][idx]);
                }
            } else {
                val = MQTTKeyMap[source][idx].processData(val, data, vehicle, MQTTKeyMap[source][idx].key, MQTTKeyMap[source][idx]);
            }
            const config = MQTTKeyMap[source][idx];
            const conditionPasses = config.condition ? config.condition(val, data, vehicle) : true;
            if(conditionPasses && val !== undefined) {
                const targetKey = config.key
                vehicle.stats[targetKey] = val;
            }
        }

        if(!vehicle.stats.utctime || data.uts > vehicle.stats.utctime){
            if(this.props.lastLoc && this.props.lastLoc.active === true){
                vehicle.stats.utctime = data.vuts;
            }else{
                vehicle.stats.utctime = data.uts;
            }
        }

        if(this.props.lastLoc && this.props.lastLoc.active === true){
            vehicle.stats.lat = data.vlt;
            vehicle.stats.lng = data.vln;
        }else{
            vehicle.stats.lat = data.lt;
            vehicle.stats.lng = data.ln;
        }

        vehicle.onroad = this.checkRoaded(vehicle.vehiclemeta);
        vehicle.showable = this.isShowable(vehicle,  this.props.roadStats);
        vehicle.searchStrMatch = this.isSearchStrMatch(vehicle,  this.searchStr);

        //vehicle.shouldUpdate = true;

    }

    checkRoaded (vehiclemeta) {
        if (vehiclemeta && "onroad" in vehiclemeta && (vehiclemeta.onroad === false || vehiclemeta.onroad === "false")) {
            return false
        }

        return true
    };

    isAllowed (vehicle) {
        return !this.allowedVehicles || this.allowedVehicles.data.indexOf(vehicle.id) !== -1;
    }

    isMultiSearchConditionValid(condition, vehicle) {

        if(!(vehicle.stats))
            return true;

        switch (condition.operator) {
            // '==', '<', '>', '<=', '>=', '!='
            case '==':
                return vehicle.stats[condition.key] == condition.value;


            case '<':
                return vehicle.stats[condition.key] < condition.value;


            case '>':
                return vehicle.stats[condition.key] > condition.value;


            case '<=':
                return vehicle.stats[condition.key] <= condition.value;


            case '>=':
                return vehicle.stats[condition.key] >= condition.value;


            case '!=':
                return vehicle.stats[condition.key] != condition.value;

            default:
                return false;

        }
    }

    isMultiSearchValid(vehicle) {
        if(this.multiSearchConditions.length) {
            for(let idx in this.multiSearchConditions) {
                if((this.multiSearchConditions[idx].str && !this.searchStringInVehicle(vehicle, this.multiSearchConditions[idx].str)) ||
                    (!this.multiSearchConditions[idx].str && !this.isMultiSearchConditionValid(this.multiSearchConditions[idx], vehicle))) {
                    return false;
                }
            }
        }
        return true;
    }


    isShowable (vehicle, config) {
        return this.isAllowed(vehicle) && ((this.checkRoaded(vehicle.vehiclemeta) && config.onroad) || (!this.checkRoaded(vehicle.vehiclemeta) && config.offroad))
    };

    isVisible (vehicle) {

        if(vehicle.showable && vehicle.searchStrMatch) {
            if(vehicle.filters && this.props.statsFilter){
                if(vehicle.filters.length === 0) {
                    return false;
                } else {
                    if(this.props.statsFilter.key === 'nocomm_2'){
                        let limit = 1000 * 60 * 60 * 24 * 2
                        let currentDate = Date.now()
                        return vehicle.filters.indexOf('nocomm') !== -1 && currentDate - vehicle.stats.lasttalkedtime > limit;
                    }else{
                        return vehicle.filters.indexOf(this.props.statsFilter.key) !== -1;
                    }
                }
            } else {
                return true;
            }
        }
        return false;
    }

    searchStringInVehicle = (vehicle, str) => {
        if(vehicle.showable && str != null && str.length >= searchConfig.singleSearch.minLength) {
            for(let idx in searchConfig.singleSearch.searchKeys) {

                if(searchConfig.singleSearch.searchKeys[idx] === "devicetype"){
                    for(let ldx in vehicle.deviceTypesList) {
                        if(vehicle.deviceTypesList[ldx].toLowerCase().indexOf(str) !== -1) 
                        return true;
                    }
                }

                if(vehicle[searchConfig.singleSearch.searchKeys[idx]] &&
                    vehicle[searchConfig.singleSearch.searchKeys[idx]].toLowerCase().indexOf(str) !== -1){
                    return true;
                } 
            }
            return false;
        }

        return vehicle.showable;
    };

    isSearchStrMatch (vehicle, str) {
        if(this.multiSearchConditions.length) {
            return vehicle.showable && this.isMultiSearchValid(vehicle);
        }
        return this.searchStringInVehicle(vehicle, str);
    }

    drawRailwayMarkers = data => {
        let marker = new window.google.maps.Marker({
            icon: {
                url: stationmarker,
                scaledSize: new window.google.maps.Size(38, 38),
            },
            position: {
                lat: data.info.center.lat,
                lng: data.info.center.lng,
            },
            title:'N/A',
            map: window.map,
        });
        marker.addListener('click',() =>{
            this.props.dispatch({
                type:actions.ADD_INTOAST,
                data:{
                    name:data.geofencename,
                    content:'Type : ' + data.info.type,
                    replace:true,
                    createAt:Date.now()
                }
            });
        });
    }


    updateVehicle = vehicle=> {
        vehicle.statsUpdatedAt = moment(Date.now()).format(dateFormatWithSec);
    };

    initInfoWindow () {
        if('google' in window) {
            if (!this.graphHandlerRef.current) {
                setTimeout(this.initInfoWindow, 100);
                return;
              }
            this.infoWindow = new InfoWindow(this.refs.dial, this.infoWindowEvents, this.onPermUpdate, this.graphHandlerRef.current)
        } else {
            setTimeout(this.initInfoWindow, 50);
        }
    }
    setPOImarker = (data) => {
        let setData = data[0]
        for(let idx in data){
            let marker = new window.google.maps.Marker({
                icon: {
                    url: expMarker,
                    scaledSize: new window.google.maps.Size(30, 30),
                },
                position: {
                    lat: data[idx].lat,
                    lng: data[idx].lng,
                },
                title:data[idx].poiname || 'N/A',
                map: window.map,
            });
        }
    }
    callListApi = async (id) =>{
        let body = {
            groupid: id
        }
        const resp = await UserAPIs.getPoiList(body)
        this.setPOImarker(resp)
    }
    setPoi () {
        let groups = this.props.groupTree
        if(groups.children){
            for(let idx in groups.children){
                let group = groups.children[idx]
                if(group.groupid !== 0) this.callListApi(group.groupid)
            }
        }
    }

    openDial(){
        this.closeDial(false);
        this.selectedVehicleByMarker = this.selectedVehicle;
        if(window.map) {
            this.zoomLevelByMarker = window.map.getZoom();
        }
        this.infoWindowStatus = true;
        if(this.mqtt) {
            if(this.selectedVehicle.type === 'user') {
                this.mqtt.subscribePhoneInfo(this.selectedVehicle.userid, true);
            } else {
                this.mqtt.subscribeCAN(this.selectedVehicle.vehicleid, true);
            }
        }

        let rightPaneVehicle = [
            'Asphalt Paver P5320',
            'user',
            'Compactor',
            'agro2500',
        ].map(i=>{return i.trim().toLowerCase()});

        let rightPaneAndDialVehicle = [
            'TVS_POC',
            'TORK'
        ].map(i=>{return i.trim().toLowerCase()});

        let groups = this.props.groupTree.children.map(f => f.path).filter(f => f);

        let modelName = ((this.selectedVehicle && this.selectedVehicle.vehiclemeta ? this.selectedVehicle.vehiclemeta.model : '') || '').trim().toLowerCase();

        let shouldIOpenRightSidePopup = this.infoWindow && this.map && this.selectedVehicle && rightPaneVehicle.indexOf(modelName) !== -1;
        let shouldIOpenDial = !shouldIOpenRightSidePopup;
        if(shouldIOpenDial) {
            shouldIOpenRightSidePopup = this.infoWindow && this.map && this.selectedVehicle && rightPaneAndDialVehicle.indexOf(modelName) !== -1;
        }

        if(this.selectedVehicle && this.selectedVehicle.tpmsconfig) {
            shouldIOpenRightSidePopup = true;
        }
        const etrioViewGroups = window.evGroups || [];
        if(etrioViewGroups.map(f => groups.filter(g => g.includes(f)).length > 0).includes(true)) {
            shouldIOpenRightSidePopup = true;
        }

        if(shouldIOpenRightSidePopup) {
            this.props.dispatch({ type:actions.RIGHT_PANE_TOGGLED, data:true});
        }

        if(shouldIOpenDial && this.map){
            // this.infoWindow.update(this.selectedVehicle.vehiclemeta);
            this.infoWindow.open(this.map.getMap(), this.selectedVehicle);
            this.infoWindow.update(this.selectedVehicle);
        }

        let shouldIShowAddress = true;
        // if(shouldIShowAddress) {
        //     this.props.dispatch({
        //         type:actions.ADD_INTOAST,
        //         data:{
        //             name: this.selectedVehicle.vehicleno + ' - (' + this.selectedVehicle.stats.lat + ',' + this.selectedVehicle.stats.lng + ')',
        //             content:this.selectedVehicle.stats.address,
        //             replace:true,
        //             createAt:Date.now(),
        //             viewInMap : true,
        //             lat : this.selectedVehicle.stats.lat,
        //             lng : this.selectedVehicle.stats.lng,
        //         }
        //     });
        // }
        this.callAddress = setInterval(() => {
            if (this.selectedVehicle && this.selectedVehicle.GPS){

                if (this.selectedVehicle.GPS.lt && this.selectedVehicle.GPS.ln){
                    if((this.selectedVehicle.GPS.lt !== window.selectedLatLng.lat) || (this.selectedVehicle.GPS.ln !== window.selectedLatLng.lng)){
                        let payload = {
                            data: [[this.selectedVehicle.GPS.lt, this.selectedVehicle.GPS.ln]],
                            token: window.getAuth().token
                         }
                         window.selectedLatLng.lat = this.selectedVehicle.GPS.lt
                         window.selectedLatLng.lng = this.selectedVehicle.GPS.ln
                        GeoCodeAPIs.getMapAddress(payload).then((resp) => {
                        if(resp && resp[0]){
                            this.props.dispatch({
                                type: actions.ADD_INTOAST_LOCATION,
                                data: {
                                    name: this.selectedVehicle.vehicleno + ' - (' + this.selectedVehicle.GPS.lt + ',' + this.selectedVehicle.GPS.ln + ')',
                                    content: resp[0].address,
                                    replace: true,
                                    createAt: Date.now(),
                                    onceIWasNew: true,
                                    viewInMap : true,
                                    lat : this.selectedVehicle.stats.lat,
                                    lng : this.selectedVehicle.stats.lng,
                                }
                            });
                        }
                         }, (err) => {
                            console.log(err)
    
                         })
                    }
                     
                }
            }

        },20000)

    }

    closeDial(clearSelectedVehicle = true){
        this.props.dispatch({ type:actions.RIGHT_PANE_TOGGLED, data:false});
        this.props.dispatch({ type:actions.SETTINGS_PANE_TOGGLED, data:false});
        this.props.dispatch({ type:actions.DTC_TOGGLED, data:false});
        this.infoWindowStatus = false;
        if(this.infoWindow)this.infoWindow.close();
        clearInterval(this.callAddress)
        window.selectedLatLng = { lat: null, lng:null}
        if(clearSelectedVehicle) {
            this.selectedVehicleByMarker = null;
            this.zoomLevelByMarker = null;
        }
        if(this.mqtt) {
            if(this.selectedVehicle) {
                this.mqtt.subscribeCAN(this.selectedVehicle.vehicleid, false);
                if(this.selectedVehicle.userid) {
                    this.mqtt.subscribePhoneInfo(this.selectedVehicle.userid, false);
                }
            }
            if(this.prevSelectedVehicle) {
                this.mqtt.subscribeCAN(this.prevSelectedVehicle.vehicleid, false);
                if(this.prevSelectedVehicle.userid) {
                    this.mqtt.subscribePhoneInfo(this.prevSelectedVehicle.userid, false);
                }
            }
        }
        // this.props.dispatch({
        //     type:actions.UPDATE_INTOAST_LIST,
        //     data: []
        // });
    }
    
    showAlerts = (msg) => {
        let gname = []
        let finalNames = []
        let pulloutFlag = window.userInfo && window.userInfo.SELF ? window.userInfo.SELF.enable_devicepullout : null
        if(!window.panicButtonAlerts) window.panicButtonAlerts = {};
        if(!window.devicePullOuts) window.devicePullOuts = {}
        if(!window.pulloutResolved) window.pulloutResolved = {}
        for(let i in msg) {
            let dmsg = msg[i];
            if(dmsg.pn) {
                let oldTime = window.panicButtonAlerts[dmsg.vp] || 0;
                if(oldTime !== dmsg.pnt) {
                    window.panicButtonAlerts[dmsg.vp] = dmsg.pnt;
                    let vno = this.getVehicleMap()[dmsg.vp].vehicleno;
                    let groupName = this.getVehicleMap()[dmsg.vp].groupnames
                    gname = groupName.split(',')
                    for(let i = 0; i<gname.length; i++){
                        finalNames[i] = gname[i].replace('/','')
                    }
                   if(gname.length > 3){
                    finalNames = gname.slice(finalNames.length - 3, finalNames.length)
                   }
                   let finalString = ''
                    finalString =  finalNames.join(', ') 
                    // console.log("group nme",finalNames,finalString,this.getVehicleMap()[dmsg.vp])
                    this.props.dispatch({
                        type: actions.ADD_INTOAST,
                        data: {
                            name: 'Panic button triggered!',
                            content: 'Panic button triggered by ' + vno +' (' + finalString+ ')' + ' at ' + moment(dmsg.pnt).format('hh:mm a'),
                            createAt: dmsg.pnt,
                        }
                    });

                    if (window.auth.userinfo.username.indexOf(".ic") === -1) {
                        try {
                            // Use preloaded audio instance to avoid repeated network requests
                            const audio = this.getAlarmAudioInstance();
                            
                            if (audio) {
                                if(this.props.muteAudio && this.props.muteAudio.active !== undefined && this.props.muteAudio.active){
                                    audio.pause();
                                    audio.muted = true;
                                } else {
                                    // Handle autoplay policy - catch promise rejection if browser blocks audio
                                    audio.play().catch(error => {
                                        // Silently handle autoplay blocking - browser requires user interaction first
                                        console.debug("Audio play blocked by browser autoplay policy:", error);
                                    });
                                }
                            }
                            // If audio is null, silently skip (don't block UI or stop processing other alerts)
                        } catch (error) {
                            // Silently handle any audio creation/playback errors to prevent UI blocking
                            console.debug("Alarm audio playback failed (non-critical):", error);
                        }
                    }
                }
            }
            if(dmsg.po && window.gotAllBuckets && pulloutFlag){
                setTimeout(() => {
                    let vno = this.getVehicleMap()[dmsg.vp].vehicleno;
                    if(dmsg.po === 1){
                        let oldTime = window.devicePullOuts[dmsg.vp] || 0;
                        if(oldTime !== dmsg.pot) {
                            this.props.dispatch({
                                type: actions.ADD_INTOAST,
                                data: {
                                    name: 'Device Pullout',
                                    content: 'Device pulled out from the vehicle No ' + vno  + ' at ' + moment(dmsg.pot).format('hh:mm a'),
                                    createAt: dmsg.pot,
                                }
                            });
                            window.devicePullOuts[dmsg.vp] = dmsg.pot;
                        }
                    }
                    if(dmsg.po === 2){
                        let resovedOld = window.pulloutResolved[dmsg.vp] || 0;
                        if(resovedOld !== dmsg.pot){
                            window.pulloutResolved[dmsg.vp] = dmsg.pot;
                            this.props.dispatch({
                                type: actions.ADD_INTOAST,
                                data: {
                                    name: 'Device Pullout Resolved',
                                    content: 'device pulled issue resolved for vehicle No ' + vno  + ' at ' + moment(dmsg.pot).format('hh:mm a'),
                                    createAt: dmsg.pot,
                                }
                            });
                        }
                    } 
                }, 1000);
            }
        }
    }

    getVehicleMap = () => window.mqttVehicleMap.vehicleMap; 

    updateMarker = (vehicle, bounds) => {

        vehicle.markerVisible = this.isVisible(vehicle);

        if(!vehicle.marker) {
            this.map.createMarker(vehicle, deepFreeze);

            vehicle.marker.addListener('click', () => {
                this.setVehicle(vehicle);
            });

            vehicle.marker.addListener('rightclick', () => {
                this.setVehicle(vehicle, false);
                window.bufferMapResize = true;

                window.toggleReportWindow = true
                window.setReportName = false
                this.props.dispatch({ type:actions.TOGGLE_REPORT_WINDOW });
                this.props.dispatch({
                    type:actions.TOGGLE_REPORT_WINDOW_TAB,
                    data:this.props.reports[0]
                });

                setTimeout(()=>{
                    window.callMarkerRightClickListener({
                        vehicle,
                        starttime: moment(Date.now()).startOf('day').add(-48, 'hour').unix() * 1000,
                        endtime: moment(Date.now()).add(0, "day").startOf("day"),
                    });
                }, 100);
            });
        } else if(!deepFreeze) {
            // if(this.isVehicleInBounds(vehicle, bounds, true, false)) {
                // console.log(vehicle.vehicleno)
                vehicle.marker.update(vehicle);
            // }
            // vehicle.shouldUpdate = false;
        }
        
        // if(!(vehicle.visible || (updateFromSearch && vehicle.searchStrMatch))) {
        //     vehicle.shouldUpdate = true;
        // }
    };


    setVehicle = (vehicle, openDial=true) => {
        // console.log(vehicle);
        this.prevSelectedVehicle = this.selectedVehicle;
        this.selectedVehicle = vehicle;
        window.itemClicked = true
        window.canDataVehicle = vehicle.vehicleno
        window.vehicleUpdated(this.selectedVehicle);
        window.selectedItems = [
            {
                data:this.selectedVehicle,
                id:this.selectedVehicle.id,
                name:this.selectedVehicle.vehicleno
            }
        ]

        if(window.polyline) {
            window.polyline.setMap(null);
            window.polyline = null;
        }

        if (window.startMarker) {
            console.log("startmakrer")
            window.startMarker.setVisible(false);
            window.pointerMarker.setVisible(false);
            window.endMarker.setVisible(false);
        }

        if(openDial) {
            this.openDial();
            window.openDial = true
            window.onMarkerClicked = true
            document.title = " Track - IC Cluster / EV Cluster"
            setTimeout(() => {
                // console.log("this.refs",this.mqttRef,this.graphHandlerRef)

            },1000)
            this.mqttRef.onReceiveMsg({vp:this.selectedVehicle.vehicleid}, 'CAN');
        }
    };

    updateStats(arr, checkRoad=false, markerFullUpdate=false, config = {}, vmap){
        
        if (updateStatsCalled) {
            console.log("returning")
            return
        }
            
        updateStatsCalled = true

        if(!vmap) {
            vmap = window.vehicleMap;
        }

        let updateFromSearch = config.updateFromSearch || false;
        let forceMakerVisibilityUpdate = 'forceMakerVisibilityUpdate' in config ? config.forceMakerVisibilityUpdate : true;

        trackTime("UpdateStats");

        

        let path;
        let matchedVehicles = [];
        let currentVehicle;

        // console.log("updateStats", updateStatsCount, checkRoad, markerFullUpdate, config, arr.length)
        let bounds = window.map ? window.map.getBounds() : null


        // let starttime = new Date().getTime()
        for(let idx in arr){
            path = arr[idx].vp || arr[idx].vehicleid || arr[idx].id;
            if(arr[idx].type === 'user') {
                path = 'user_' + arr[idx].id;
            }

            if(vmap[path] && vmap[path].stats){
                currentVehicle = vmap[path];
                if(checkRoad){
                    currentVehicle.onroad = this.checkRoaded(currentVehicle.vehiclemeta);
                    currentVehicle.showable = this.isShowable(currentVehicle,  this.props.roadStats);
                    currentVehicle.searchStrMatch = this.isSearchStrMatch(currentVehicle, this.searchStr);
                    if(currentVehicle.searchStrMatch) {
                        matchedVehicles.push(currentVehicle)
                    }
                }
                // this.updateVehicle(currentVehicle);
                this.updateMarker(currentVehicle, bounds);
                // if(currentVehicle && currentVehicle.marker && forceMakerVisibilityUpdate && !deepFreeze) {
                //     currentVehicle.marker.setVisibilty(currentVehicle);
                // }
            }
        }
        // let endtime = new Date().getTime()

        // console.log("time taken", endtime - starttime)

        // console.log(stats);

        // this.props.dispatch({
        //     type: actions.STATS_UPDATED,
        //     data: stats
        // });

        window.setClickedVehicle = v => this.setVehicle(v);

        trackTime("UpdateStats");

        /*
        *   Debug Code
        * */

        if(debugStats) {

            let tempStats = {}; // mutually exclusive buckets
            let allocatedBuckets;
            let unallocatedVehicles = [];
            let blacklistBuckets = ['mil', 'allvehicles', 'tampered', 'badBatteryHealth', 'nocomm-kle'];
            let blacklisted;
            let total = 0;
            let redundantMaping = {};

            for (let key in stats) {
                blacklisted = false;
                
                for(let idx in this.props.statsConfig) {
                    if(this.props.statsConfig[idx].key === key && this.props.statsConfig[idx].parent) {
                        blacklisted = true;
                        break;
                    }
                }

                for (let jdx in blacklistBuckets) {
                    if (key === blacklistBuckets[jdx]) {
                        blacklisted = true;
                        break
                    }
                }
                if (blacklisted)
                    continue;
                tempStats[key] = [];
            }

            for (let idx in stats.allvehicles) {
                allocatedBuckets = [];
                for (let key in tempStats) {
                    if (stats[key].indexOf(stats.allvehicles[idx]) !== -1) {
                        allocatedBuckets.push(key);
                    }
                }

                if (allocatedBuckets.length > 1) {
                    let mapKey = allocatedBuckets.sort().join('|')
                    if(!redundantMaping[mapKey]) {
                        redundantMaping[mapKey] = [];
                    }
                    redundantMaping[mapKey].push(this.getVehicleMap()[stats.allvehicles[idx]])
                    for (let idx in allocatedBuckets) {
                        tempStats[allocatedBuckets[idx]].push(stats.allvehicles[idx]);
                    }
                }

                if (allocatedBuckets.length === 0) {
                    unallocatedVehicles.push(stats.allvehicles[idx]);
                }
                total+=allocatedBuckets.length;
            }

            let str = "";
            for (let idx in tempStats) {
                if (tempStats[idx].length > 0) {
                    str += idx + ' : ' + tempStats[idx].length + ', '
                }
            }

            if (str.length) {
                console.log('REDUNDANT ASSETS : ', str);
                console.log(redundantMaping);
            }

            console.log('allocated: ', total, 'diff: ', (stats.allvehicles ? stats.allvehicles.length - total : 0), 'unallocated: ', unallocatedVehicles.map(item=>{return this.getVehicleMap()[item] ? this.getVehicleMap()[item] : item}));

        }

        updateStatsCalled = false
        // console.log("Ending updateStats")


        return {matchedVehicles}
    }


    turnOffAllOverlays(){

        if(!this.props.overlayFilters)
            return;

        let data = {};
        let enabled = false;
        for(let key in this.props.overlayFilters.data) {
            if(this.props.overlayFilters.data[key]) {
                enabled = true;
            }
        }

        if(enabled) {
            for(let key in this.props.overlayFilters.data) {
                data[key] = false;
            }
            this.props.dispatch({
                type:actions.OVERLAY_FILTER_UPDATED,
                data: {
                    data,
                    updatedAt:Date.now()
                }
            });
        }
    }


    checkStatCondition(vehicle, conditions){
        for(let key in conditions){
            switch (conditions[key][0]){
                case ">":
                    if(!(vehicle.stats[key] > conditions[key][1]))
                        return false;
                    break;
                case "==":
                    if(!(vehicle.stats[key] == conditions[key][1]))// eslint-disable-line
                        return false;
                    break;
                case "!=":
                    if(!(vehicle.stats[key] != conditions[key][1]))// eslint-disable-line
                        return false;
                    break;
                case "<":
                    if(!(vehicle.stats[key] < conditions[key][1]))
                        return false;
                    break;
                case ">=":
                    if(!(vehicle.stats[key] >= conditions[key][1]))
                        return false;
                    break;
                case "<=":
                    if(!(vehicle.stats[key] <= conditions[key][1]))
                        return false;
                    break;
                default:
                    return false;
            }
        }
        return true;
    }


    roadStatsChanged(roadStats){
        if(roadStats.offroad === localRoadStats.offroad && roadStats.onroad === localRoadStats.onroad)
            return;

        // console.log("roadStatsChanged")

        setTimeout(()=>{
            this.updateStats(this.getVehicleMap(), true, false);
            // this.refreshAllVehicles();
            this.turnOffAllOverlays();
            // this.triggerSingleSearch()
            this.closeDial();
        }, 10);

        localRoadStats = {...roadStats};
    }
    lastLocChanged = (lastloc) => {
        if(lastloc.active !== undefined){
            if(lastloc.active === true){
                let vehicleMap = this.getVehicleMap()
                for(let vehicle in vehicleMap) {
                    if( vehicleMap[vehicle].GPS && vehicleMap[vehicle].GPS.vlt && vehicleMap[vehicle].GPS.vln && vehicleMap[vehicle].GPS.vuts) {
                        vehicleMap[vehicle].stats.lat = vehicleMap[vehicle].GPS.vlt
                        vehicleMap[vehicle].stats.lng = vehicleMap[vehicle].GPS.vln
                        vehicleMap[vehicle].stats.utctime = vehicleMap[vehicle].GPS.vuts;
                    }
                    
                }
                setTimeout(() => {
                    this.updateStats(vehicleMap, true, false)
                },100)
            }
            if(lastloc.active === false){
                let vehicleMap = this.getVehicleMap()
                for(let vehicle in vehicleMap) {
                    if( vehicleMap[vehicle].GPS && vehicleMap[vehicle].GPS.lt && vehicleMap[vehicle].GPS.ln && vehicleMap[vehicle].GPS.uts) {
                        vehicleMap[vehicle].stats.lat = vehicleMap[vehicle].GPS.lt
                        vehicleMap[vehicle].stats.lng = vehicleMap[vehicle].GPS.ln
                        vehicleMap[vehicle].stats.utctime = vehicleMap[vehicle].GPS.uts;
                    }
                }
                setTimeout(() => {
                    this.updateStats(vehicleMap, true, false)
                },100)
            }
        }
    }


    triggerSingleSearch() {
        if(this.searchStr && this.searchStr.length) {
            // console.log("triggerSingleSearch", this.searchStr)
            this.singleSearch(this.searchStr, true, false);
        }
    }


    // refreshAllVehicles(callback = ()=>{}){
    //     setTimeout(()=>{
    //         if(this.getVehicleMap()) {
    //             let vehicles = this.getVisibleVehicles(true);
    //             for(let idx in vehicles.all){
    //                 vehicles.all[idx].onroad = this.checkRoaded(vehicles.all[idx].vehiclemeta);
    //                 vehicles.all[idx].showable = this.isShowable(vehicles.all[idx],  this.props.roadStats);
    //                 vehicles.all[idx].searchStrMatch = this.isSearchStrMatch(vehicles.all[idx], this.searchStr);
    //                 vehicles.all[idx].markerVisible = this.isVisible(vehicles.all[idx]);
    //                 if(vehicles.all[idx].marker && vehicles.all[idx].visible){
    //                     vehicles.all[idx].shouldUpdate = false;
    //                     vehicles.all[idx].marker.setVisible(deepFreeze ? false : vehicles.all[idx].markerVisible);
    //                 }else if(!vehicles.all[idx].visible){
    //                     vehicles.all[idx].shouldUpdate = true;
    //                 }
    //             }
    //             callback();
    //         }
    //     }, 10);
    // }


    reportWindowChanged(reportWindow){
        if(!this.reportWindow || reportWindow.visible !== this.reportWindow.visible) {
            // console.log("reportWindowChanged", reportWindow.visible)
            // this.reportWindow = {...reportWindow};
            this.deepFreezeMode(reportWindow.visible);
            if(reportWindow.visible){
                this.closeDial(false);
            } else {
                if(this.reportWindow && this.selectedVehicleByMarker && !this.infoWindowStatus) {
                    setTimeout(()=>{
                        this.setVehicle(this.selectedVehicleByMarker);
                        if(this.zoomLevelByMarker && window.map) {

                            window.map.setCenter({
                                lat:this.selectedVehicleByMarker.stats.lat,
                                lng:this.selectedVehicleByMarker.stats.lng
                            });
                            window.map.setZoom(this.zoomLevelByMarker);
                        }
                        this.selectedVehicleByMarker = null;
                    }, 100);
                }
            }
        }
    };


    statsFilterChanged(statsFilter){
        if(statsFilter && (!localStatsFilter.key || statsFilter.key !== localStatsFilter.key)){
            localStatsFilter = statsFilter;

            // console.log("statsFilterChanged")

            trackTime('stateChanged', true);
            this.updateStats(this.getVehicleMap(), true, false);
            trackTime('stateChanged', true);

            // this.refreshAllVehicles();
            this.turnOffAllOverlays();
            // this.triggerSingleSearch();
            this.closeDial();
        }
    };


    deepFreezeMode(action){
        deepFreeze = action;

        const hideAllMarkers = () => {
            let vmap = this.getVehicleMap();
            for(let idx in vmap){
                if(vmap[idx].marker) {
                    vmap[idx].marker.setVisible(false);
                }
            }
        };

        const showAllMarkers = () => {
            this.updateStats(this.getVehicleMap(), true, false);
            // let vmap = this.getVehicleMap();
            // for(let idx in vmap){
            //     if(vmap[idx].marker && vmap[idx].markerVisible){
            //         vmap[idx].marker.setVisible(true);
            //     }
            // }
        };

        if(action){
            setTimeout(hideAllMarkers, 100);
        }else{
            setTimeout(showAllMarkers, 100);
        }
    }


    /*
    *
    *   search
    *
    * */

    evaluateString(str) {
        let conditions = (str||'').split('&');
        let validConditions = [];
        let keys;
        let tempCondition;
        let valid = false;
        for(let idx in conditions) {
            keys = conditions[idx].split(':');
            if(keys.length < 2) {
                keys = keys[0];
                if(!keys || keys.length < 1 || keys == '')
                    continue;
                tempCondition = {
                    str:(keys||'').trim().toLowerCase()
                };
            } else {
                keys = keys[1].split(' ');
                if(keys.length < 3)
                    continue;
                tempCondition = {
                    key:keys[0],
                    operator: keys[1],
                    value:isNaN(parseFloat(keys[2])) ? keys[2] : parseFloat(keys[2])
                };
                valid = true;
            }
            validConditions.push(tempCondition);
        }

        this.multiSearchConditions = valid ? validConditions : [];
        this.props.dispatch({
            type:actions.MULTI_SEARCH_CONDTIONS,
            data:this.multiSearchConditions
        });
    }

    singleSearch(str='', force=false){

        // console.log("singleSearch", str, force)

        let singleSearchStr = ((str||'')+"").trim().toLowerCase();
        let geoResults = [];
        if(this.searchStr == null){
            this.searchStr = singleSearchStr;
        }

        if(this.searchStr !== singleSearchStr || force){
            trackTime('Searching');
            this.searchStr = singleSearchStr;
            for(let idx in this.geofences.data) {
                if(this.geofences.data[idx].info && this.props.geofenceFilters.data[this.geofences.data[idx].info.type]
                    && this.geofences.data[idx].polygon
                    && this.geofences.data[idx].name.toLowerCase().indexOf(this.searchStr) !== -1) {
                    this.geofences.data[idx].polygon.setVisible(true);
                    geoResults.push(this.geofences.data[idx]);
                } else if(this.geofences.data[idx].polygon) {
                    this.geofences.data[idx].polygon.setVisible(false);
                }
            }

            this.searchResults = this.updateStats(this.getVehicleMap(), true, false, {updateFromSearch:true}).matchedVehicles;
            // console.log("searchResults",this.searchResults.length)
            
            this.props.dispatch({
                type:actions.SEARCH_RESULT_UPDATED,
                data: this.searchResults
            })

            this.searchGeoResults = geoResults;
            this.setBoundsOfSearchResults();
            this.closeDial();
            this.triggerEvent('search_finished');
            trackTime('Searching');
        }
    }

    triggerEvent =(tag, params)=> {
        if(this.eventListeners && this.eventListeners[tag]) {
            for(let idx in this.eventListeners[tag]) {
                this.eventListeners[tag][idx](params);
            }
        }
    };

    addListeners =(tag, method)=> {
        if(!this.eventListeners) {
            this.eventListeners = {}
        }
        if(!this.eventListeners[tag]) {
            this.eventListeners[tag] = {};
        }
        let key = Date.now() + '-' + Math.random();
        if(!this.eventListeners[tag][key]) {
            this.eventListeners[tag][key] = method;
        }
        return ()=> {
            delete this.eventListeners[tag][key];
        }
    };

    setBoundsOfSearchResults() {

        let results = this.searchResults;
        let geoResults = this.searchGeoResults;
        let latLng = null;
        let bounds = new window.google.maps.LatLngBounds();
        let searchItem = null
        if(results)results.map((item) =>{
            if(item.vehicleno === this.searchStr.toUpperCase()){
                searchItem = item
            }else{
                searchItem = results[0]
            }
        })

        if(searchItem && searchItem.marker && searchItem.marker.position) {
            if (searchItem && searchItem.searchStrMatch && searchItem.stats) {
                // latLng = {lat: results[0].stats.lat, lng: results[0].stats.lng}
                latLng = {lat: searchItem.marker.position.lat(), lng: searchItem.marker.position.lng()}

                // if(!latLng.lat < 0  || latLng.lat > 50 || !latLng.lng < 0 || latLng.lng > 100){
                //     latLng = window.locations.USR
                // } 

            }
        } else if (geoResults[0] && geoResults[0].polygon){
            if(geoResults[0].info.structure === 'circle') {
            //    console.log(geoResults)
                latLng = geoResults[0].info.center;
                window.map.setCenter(latLng);
                if(geoResults[0].info.radius < 500){
                    window.map.setZoom(17);
                }
                else if(geoResults[0].info.radius < 3000){
                    window.map.setZoom(14);
                }
                else if(geoResults[0].info.radius < 6000){
                    window.map.setZoom(12);
                }
                else if(geoResults[0].info.radius > 6000){
                    window.map.setZoom(10);
                }
    
            }else{
                latLng = geoResults[0].info.coords;
                let coords;
                    for(let idx in latLng) {
                        coords = latLng[idx];
                        bounds.extend(new window.google.maps.LatLng(coords.lat, coords.lng));
                    }
                    this.fitBounds(bounds)

            }
        }

        if(!latLng)
            return;

        if(this.searchStr !== '' && this.searchStr.length && !this.props.freezMap.active) {
            window.map.setZoom(17);
            window.map.setCenter(latLng)
        }
    }

    fitBounds (bounds) {
        if(this.props.freezMap.active) return;

        setTimeout(()=>{
            this.map.fitBounds(bounds);
        });
    }

    getVisibleVehicles (showable, all) {
        let bounds = window.map.getBounds();
        let filtered = {visible:{}, invisible:{}};
        let vmap = this.getVehicleMap();
        for(let idx in vmap) {
            if(this.isVehicleInBounds(vmap[idx], bounds, showable, all)) {
                filtered.visible[vmap[idx].vehicleid] = vmap[idx];
            } else {
                filtered.invisible[vmap[idx].vehicleid] = vmap[idx];
            }
        }
        filtered.all = {...filtered.visible, ...filtered.invisible};
        return filtered;
    }

    isVehicleInBounds(vehicle, bounds, showable=false, all=false) {
        // vehicle.breakPointData = {
        //     bounds,
        //     showable,
        //     all,
        // };

        if(vehicle.stats && bounds && (all || (!showable && vehicle.markerVisible) || (showable && vehicle.showable))) {
            // right = bounds.getNorthEast().lat(); 
            // left = bounds.getSouthWest().lat(); 
            // top = bounds.getNorthEast().lng(); 
            // bottom = bounds.getSouthWest().lng(); 
            // lat = vehicle.stats.lat;
            // lng = vehicle.stats.lng;

            // console.log(vehicle)

            // var latlng = new window.google.maps.LatLng(lat, lng);

            //if(lat > left && lat < right && lng >bottom && lng < top) {
            let latlng = vehicle.marker.getPosition()
            if(latlng && bounds.contains(latlng)) {
                // console.log("visible", vehicle.vehicleno)
                // vehicle.visible = true;
                // vehicle.breakPoint = 'FIRST';
                return true;
            } else {
                // console.log("not visible", vehicle.vehicleno)
                // vehicle.visible = false;
                // vehicle.breakPoint = 'SECOND';
                return false;
            }
        }

        // vehicle.visible = true;
        // vehicle.breakPoint = 'THIRD';

        return true;
    }

    /*
    *
    *
    *
    * */

    zoomChanged(){
        if(this.zoomTrigger){
            clearTimeout(this.zoomTrigger);
        }

        this.zoomTrigger = setTimeout(() => {
            if(deepFreeze)
                return;

            trackTime("ZoomChanged");
            // this.updateStats(this.getVehicleMap(), true, false);
            this.zoomTrigger = null;
            trackTime("ZoomChanged");
        }, 1000)
    }

    tilesLoaded(){
        return;

        if(this.tileUpdateTrigger){
            clearTimeout(this.tileUpdateTrigger);
        }

        this.tileUpdateTrigger = setTimeout(() => {
            if(deepFreeze)
                return;
            trackTime('tilesLoaded');

            // do not uncomment - smiddela
            // let vehicles = this.getVisibleVehicles(true);
            // for(let idx in vehicles.visible){
            //     if(vehicles.visible[idx].marker && vehicles.visible[idx].shouldUpdate){
            //         if(vehicles.visible[idx].marker){
            //             vehicles.visible[idx].marker.update(vehicles.visible[idx]);
            //             vehicles.visible[idx].shouldUpdate = false;
            //         }
            // }

            // this.updateStats(this.getVehicleMap(), true, false);
            trackTime('tilesLoaded');
            this.tileUpdateTrigger = null;
        },500)
    }

    getMapListeners(){
        return {
            zoom_changed:this.zoomChanged,
            tilesloaded:this.tilesLoaded,
            click:this.closeDial,
            rightclick:this.closeDial
        }
    };

    MQTTLoaded(mqtt) {
        this.mqtt = mqtt;
    }

    geofenceChanged(geofences) {
        if(!this.geofences || !this.geofences.reqTime === geofences.reqTime) {
            this.geofences = geofences;
            if(!this.geofences)
                return;

            for(let idx in this.geofences.data) {
                if(this.geofences.data[idx].polygon && this.geofences.data[idx].polygon.setMap) {
                    this.geofences.data[idx].polygon.setMap(null);
                }
            }
            // this.geofences = _.cloneDeep(geofences);
            this.geofences = geofences;
            for(let idx in this.geofences.data) {
                if(this.geofences.data[idx].info) {
                    this.drawPolygonOnMap(this.geofences.data[idx])
                }
            }
        }
    }

    geofenceFiltersChanged(filters) {
        if(!this.geofenceFilters || this.geofenceFilters.updatedAt !== filters.updatedAt) {
            this.geofenceFilters = filters;
            this.updateGeofence();
        }
    }

    overlayFiltersChanged(filters) {
        if(!this.overlayFilters || this.overlayFilters.updatedAt !== filters.updatedAt) {
            // console.log("overlayFiltersChanged")

            this.overlayFiltersPrev = _.cloneDeep(this.overlayFilters);
            if(!this.overlayFiltersPrev)
                this.overlayFiltersPrev = {data:{}};

            this.overlayFilters = filters;
            let shouldRun = false;
            let vehicleNumberOnly = null;

            let config = {
                noComm:{color:'red',    condition:v=>{return v.stats.nocomm > 0}},
                lowVB: {color:'orange', condition:v=>{return v.stats.carbattery < 9.5}},
                lowDB: {color:'yellow', condition:v=>{return v.stats.devicebattery < 3.55}},
                vehNo: {vehicleNo:true, condition:()=>{return true}},
            };

            for(let key in config) {
                if(filters.data[key]) {
                    config[key].status = 1;
                    shouldRun = true;
                    if(key === 'vehNo') {
                        if(vehicleNumberOnly === null) {
                            vehicleNumberOnly = true;
                        }
                    }else{
                        vehicleNumberOnly = false;
                    }
                } else if(this.overlayFiltersPrev.data[key]) {
                    config[key].status = 0;
                    shouldRun = true;
                }
            }

            if(shouldRun) {
                let vehicles = this.getVisibleVehicles(true);
                for(let idx in vehicles.visible) {
                    this.updateOverlay(vehicles.visible[idx], config);
                }
                if(!vehicleNumberOnly){
                    setTimeout(()=>{
                        for(let idx in vehicles.invisible) {
                            this.updateOverlay(vehicles.invisible[idx], config);
                        }
                    }, 1000);
                }
            }
        }
    }

    overlayShow(vehicle, config, idx){
        if(vehicle.overlay) {
            vehicle.overlay.show();
            if(config.vehicleNo) {
                vehicle.overlay.showVehicleNumber();
            }else{
                vehicle.overlay.highlight(config.color);
            }
            if(vehicle.activeOverlay.indexOf(idx) === -1) {
                vehicle.activeOverlay.push(idx);
            }
            return false;
        }else{
            vehicle.overlay = new CustomOverlay(vehicle.stats.lat, vehicle.stats.lng, window.map, {vehicle});
            setTimeout(()=>{
                this.overlayShow(vehicle, config);
            },1000);
            return true;
        }
    }

    updateOverlay (vehicle, config) {
        let vehicleShouldHide = true;
        if(!vehicle.activeOverlay) {
            vehicle.activeOverlay = [];
        }
        if(vehicle.showable && vehicle.markerVisible && vehicle.marker && vehicle.marker.visible) {
            for(let idx in config) {
                if(config[idx].status === 1) {
                    if(vehicle.stats && config[idx].condition(vehicle) && vehicle.activeOverlay.indexOf(idx) === -1) {
                        vehicleShouldHide = this.overlayShow(vehicle, config[idx], idx)
                    }
                } else if(config[idx].status === 0 && vehicle.overlay) {
                    if(config[idx].vehicleNo) {
                        vehicle.overlay.hideVehicleNumber();
                    }else {
                        vehicle.overlay.unhighlight(config[idx].color);
                    }
                    if(vehicle.activeOverlay.indexOf(idx) !== -1) {
                        vehicle.activeOverlay.splice(vehicle.activeOverlay.indexOf(idx));
                    }
                }
            }
        }
        if(vehicleShouldHide && vehicle.overlay) {
            vehicle.overlay.hide();
            vehicle.overlay.setMap(null);
            delete vehicle.overlay;
        }

    }

    /*
    *
    *   Dial Methods
    *
    * */

    onImmobWindowClose () {
        this.setState({immobWindowVisiblity: false})
    }

    onImmobCWindowClose () {
        this.setState({immobCWindowVisiblity: false})
    }
    closeLocShare () {
        this.setState({shareLink:false})
    }

    onLockWindowClose () {
        this.setState({lockWindowVisiblity: false})
    }

    infoWindowEvents (method, params) {
        switch (method) {
            case 'showDTC' :
                console.log("inside ctc")
                this.props.dispatch({
                    type:actions.DTC_TOGGLED,
                    data:true,
                });
                this.props.dispatch({ type:actions.RIGHT_PANE_TOGGLED, data:false});
                break;

            case 'immobilize':
                this.lastImmobState = parseInt(params, 10);
                if(this.lastImmobState) {
                    this.setState({immobCWindowVisiblity: true});
                } else{
                    this.setState({immobWindowVisiblity: true});
                }
                break;

            case 'lockunlock':
                this.lastLockState = parseInt(params, 10);
                this.setState({lockWindowVisiblity: true});
                break;

            case 'honk':
                this.honk();
                break;

            case 'showHistory':

                this.props.dispatch({
                    type:actions.TOGGLE_REPORT_WINDOW
                });

                this.props.dispatch({
                    type:actions.TOGGLE_REPORT_WINDOW_TAB,
                    data:this.props.reports[0]
                });

                setTimeout(()=>{
                    try{
                        let selectedItemId = this.props.reports[0].toolbar[0].ref.getData();
                        selectedItemId = selectedItemId && selectedItemId[0] && selectedItemId[0].data ? selectedItemId[0].data.vehicleid  : null;
                        let valid = selectedItemId === this.selectedVehicle.vehicleid;
                        // console.log(this.selectedVehicle)
                        window.itemClicked = true
                        this.props.reports[0].toolbar[0].ref.setItemById(this.selectedVehicle.vehicleid);
                        if(!valid && window.clearHistoryReport) {
                            window.clearHistoryReport();
                        }
                    } catch (e) {}
                });

                break;

            case 'showSettings':
                this.props.dispatch({
                    type:actions.SETTINGS_PANE_TOGGLED,
                    data:true
                });
                this.props.dispatch({ type:actions.RIGHT_PANE_TOGGLED, data:false});
                this.props.dispatch({ type:actions.DTC_TOGGLED, data:false});
                break;
            case 'shareLink': 
                this.setState({shareLink : true})    

            default:
        }
    }

    canIImmobilize (type) {
        if(!this.selectedVehicle || !this.selectedVehicle.stats || !this.state.permission)
            return;
        // const isLaf = () => {
        //     let deviceTypes = this.selectedVehicle.deviceTypesList || []
        //     for(let idx in deviceTypes){
        //        if(deviceTypes[idx] === "laf"){
        //            return true
        //        }
        //     }
        // }    
        // console.log(type, 'immobilize permission', this.state.permission.immobilize);
        if(type === 'CAN'){
            let can_button_active = this.selectedVehicle.vehiclemeta.immobilize_type === 'can';
            return can_button_active
        }
        else if(type==='CRANK') {
            let crank_button_active = this.state.permission.crank_immobilize && this.selectedVehicle.stats.mobilistatus == 0 && this.selectedVehicle.vehiclemeta.immobilize_type !== 'can';;

            // if (isLaf())
            //     return false;
            // console.log('crank_button_active', crank_button_active);
            return crank_button_active;
        }
        else if(type === "direct_to_output"){
            let ignition_button_active = this.state.permission.ign_immobilize
            return ignition_button_active

        } else {
            let ignition_button_active = this.state.permission.ign_immobilize && (this.selectedVehicle.stats.mobilistatus == 1 || this.selectedVehicle.vehiclemeta.immobilize_type === 'ignition');

            // if (isLaf())
            //     return true;    
            return ignition_button_active;
        }
    }

    onPermUpdate(perm) {
        this.setState({permission:perm});
        // this.setState({permission:{immobilize:true}});
    }

    handleSuccess = (resp) => {
        this.props.dispatch({
            type:actions.ADD_INTOAST,
            data:{
                name: " Command Sent Successfully",
                content:"Command sent successfully", 
                createAt:Date.now(),
                autoClose: 8000,
            }
        });
    }
    handleFailure = () => {
        this.props.dispatch({
            type:actions.ADD_INTOAST,
            data:{
                name: " Command Failed to Send",
                content:"Couldn't send the command. Please try again", 
                createAt:Date.now(),
                autoClose: 8000,
            }
        });
    }
    immobilize() {
        // if(!this.canIImmobilize(this.lastImmobType))
        //     return;
        let deviceid = this.selectedVehicle.devices.TRACKER.deviceno
        let deviceType = this.selectedVehicle.devices.TRACKER.devicetype
        const isOrix = () =>{
            if(this.selectedVehicle.groups && this.selectedVehicle.groups.length){
               for(let idx in this.selectedVehicle.groups){
                let group = this.selectedVehicle.groups[idx]
                if(group.groupid === 2252){
                    if(deviceid.startsWith('3') && deviceType.indexOf("itriangle") === 0){
                        return true
                    }
                }
                else if(group.groupid === 1947){
                    if(deviceid.startsWith('3') && deviceType.indexOf("itriangle") === 0){
                        return true
                    }
                }
               }
               return false 
            }
        }

        let body = {
            vehicleid: this.selectedVehicle.vehicleid
        };
        let outputImmobBody = {
            vehicleid: this.selectedVehicle.vehicleid,
            action: this.action
        }

        if(this.lastImmobState === 1) {
            if(isOrix()){
                let orixBody = {
                    vehicleid: this.selectedVehicle.vehicleid,
                    deviceid : this.selectedVehicle.TRACKER_deviceno
                }
                CommandAPIs.orixMobilize(orixBody).then(this.handleSuccess,this.handleFailure)
            }else{
                CommandAPIs.mobilize(body).then(this.handleSuccess,this.handleFailure);
                setTimeout(() => {
                    CommandAPIs.ignMobilize(body).then(this.handleSuccess,this.handleFailure);
                }, 5000);
            }
            if(this.lastImmobType === "CAN"){
                CommandAPIs.canMobilize(body).then(this.handleSuccess,this.handleFailure)
            }
        }else if(this.lastImmobState === 0) {
            if(isOrix()){
                let orixBody = {
                    vehicleid: this.selectedVehicle.vehicleid,
                    deviceid : this.selectedVehicle.TRACKER_deviceno
                }
                CommandAPIs.orixImmobilize(orixBody).then(this.handleSuccess,this.handleFailure)
            }
            if(this.lastImmobType==='CRANK') {
                CommandAPIs.immobilize(body).then(this.handleSuccess,this.handleFailure)
            }
            else if(this.lastImmobType === "direct_to_output") {
                CommandAPIs.outputAction(outputImmobBody).then(this.handleSuccess,this.handleFailure)
            }
            else if(this.lastImmobType === 'CAN') {
                CommandAPIs.canImmobilize(body).then(this.handleSuccess,this.handleFailure)
            }
            else if(this.lastImmobType === 'IMMEDIATE'){
                body.immediate = true
                CommandAPIs.ignImmobilize(body).then(this.handleSuccess,this.handleFailure)
            }
            else {
                CommandAPIs.ignImmobilize(body).then(this.handleSuccess,this.handleFailure)
            }
        }

        this.onImmobCWindowClose();
    }

    openImmobilizeWindow(type,buttonClicked = null) {
        if(!this.canIImmobilize(type))
            return;
        this.lastImmobType = type;
        this.action = buttonClicked ? buttonClicked : null
        this.onImmobWindowClose();
        this.setState({immobCWindowVisiblity: true});
    }

    lock(){
        let body = {
            vehicleid: this.selectedVehicle.vehicleid
        };

        if(this.lastLockState === 0) {
            CommandAPIs.lock(body).then(this.handleSuccess,this.handleFailure);
        } else if(this.lastLockState === 1) {
            CommandAPIs.unlock(body).then(this.handleSuccess,this.handleFailure);
        }
        this.onLockWindowClose();
    }

    honk(){
        let body = {
            vehicleid: this.selectedVehicle.vehicleid
        };
        CommandAPIs.honk(body).then(this.handleSuccess,this.handleFailure)
    }

    getAllowedVehicles(){
        return this.allowedVehicles ? this.allowedVehicles.data : [];
    }

    componentWillReceiveProps(props) {
        if(props.allowedVehicles && (!this.allowedVehicles || props.allowedVehicles.updatedAt > this.allowedVehicles.updatedAt)) {
            this.allowedVehicles = props.allowedVehicles;
            this.updateStats(this.getVehicleMap(), true, false);
        }
    };


    graphHandlerData = {
        key:'graph2',
        // type:schemaTypes.IN_GRAPH,
        graphType: 'graph',
        staticHandler:true,
        displayTime:true,
        displayMax:true,
        position:{ width:6, height:10, left:0, top:0},
        config:[
            {listenTo:[{api:'getSpeedInfo', key:'value'}], gradient:true, color: "#02ffa4", name:'speed'}
        ]
    };

    isTableViewActive =()=> {
        return this.props.tableView.active && !this.props.reportWindow.visible
    };

    getReportTabFromTabName =name=> {
        let tab = null;
        for(let idx in this.props.reports) {
            if(this.props.reports[idx].name.toLowerCase().indexOf(name) !== -1) {
                tab = this.props.reports[idx];
                break;
            }
        }
        return tab;
    };


    getTabFromToolName =name=> {
        let tab;
        for(let idx in this.props.reports) {
            tab = this.props.reports[idx];
            for(let idx in tab.toolbar) {
                if((tab.toolbar[idx].name || '').toLowerCase().indexOf(name) !== -1) {
                    return {
                        tab,
                        button:tab.toolbar[idx]
                    }
                }
            }
        }
        return null;
    };

    commands = [
        {
            cmds:['close report', 'show map'],
            onTrigger: (results, respond, cmdIndex)=> {
                if(this.props.reportWindow.visible) {
                    this.props.dispatch({
                        type:actions.TOGGLE_REPORT_WINDOW
                    });
                }
            }
        },
        {
            cmds:['show driving report', 'show route', 'get *'],
            onTrigger: (results, respond, cmdIndex)=> {

                let buttonName;

                if(cmdIndex == 0) {
                    buttonName = 'show driving report'
                } else if (cmdIndex == 1) {
                    buttonName = 'show route'
                } else {
                    buttonName = 'get ' + results[0]
                }

                if(this.props.reportWindow.visible) {
                    for(let idx in this.props.reportWindow.tab.toolbar) {
                        if((this.props.reportWindow.tab.toolbar[idx].name || '').toLowerCase().indexOf(buttonName) !== -1 &&
                            this.props.reportWindow.tab.toolbar[idx].triggerClick) {
                            this.props.reportWindow.tab.toolbar[idx].triggerClick();
                        }
                    }
                } else {
                    let data = this.getTabFromToolName(buttonName);
                    if(data.button && data.tab) {
                        this.props.dispatch({
                            type:actions.TOGGLE_REPORT_WINDOW
                        });
                        this.props.dispatch({
                            type:actions.TOGGLE_REPORT_WINDOW_TAB, data:data.tab
                        });
                        setTimeout(()=>{
                            if(data.button.triggerClick) {
                                data.button.triggerClick();
                            }
                        }, 1000);
                    }
                }
            }
        },
        {
            cmds:['search for * and goto *', 'search for * and go to *', 'search * and go to *', 'search * and goto *'],
            onTrigger: (results, respond)=> {
                let unsubscribe;
                window.setSearchStringAndSearch((results[0]||'').toLowerCase());
                const onSearchFinished =()=> {
                    if(stats.allvehicles.length) {
                        let vehicle = this.getVehicleMap()[stats.allvehicles[0]];
                        this.setVehicle(vehicle, false);
                        let tab = this.getReportTabFromTabName(results[1]);
                        if(tab) {
                            this.props.dispatch({
                                type:actions.TOGGLE_REPORT_WINDOW
                            });
                            this.props.dispatch({
                                type:actions.TOGGLE_REPORT_WINDOW_TAB, data:tab
                            });
                        } else {
                            respond('Im not getting where should i take you');
                        }
                    } else {
                        respond('No results found for the search string');
                    }
                    unsubscribe();
                };
                unsubscribe = this.addListeners('search_finished', onSearchFinished);
            }
        },
        {
            cmds:['search for *', 'search *', 'give me all *', 'select a *', 'select *'],
            onTrigger: (results, respond, cmdIndex)=> {
                if(window.setSearchStringAndSearch){
                    window.setSearchStringAndSearch((results[0]||'').toLowerCase());
                }
                let unsubscribe;
                const onSearchFinished =()=> {
                    if(stats.allvehicles.length) {
                        respond('Showing ' + stats.allvehicles.length + ' vehicles, ' +
                            stats.running.length + ' running and ' + stats.stopped.length + ' stopped');
                        let vehicle = this.getVehicleMap()[stats.allvehicles[0]];
                        setTimeout(()=>{
                            if(cmdIndex == 5 || cmdIndex == 6) {
                                this.setVehicle(vehicle);
                            }
                            if(window.zoomToFitView) {
                                window.zoomToFitView();
                            }
                        }, 1000);
                    } else {
                        respond('No results found for the search string *');
                    }
                    unsubscribe();
                };
                unsubscribe = this.addListeners('search_finished', onSearchFinished);
            }
        },
        {
            cmds:['goto *', 'go to *'],
            onTrigger: (results, respond)=> {
                let pageName = results[0].split(' ')[0];
                let tab = this.getReportTabFromTabName(pageName);
                if(tab) {
                    if(this.props.reportWindow && this.props.reportWindow.tab && this.props.reportWindow.tab.key === tab.key) {
                        respond('We are already on ' + tab.name);
                    } else {
                        this.props.dispatch({
                            type:actions.TOGGLE_REPORT_WINDOW
                        });
                        this.props.dispatch({
                            type:actions.TOGGLE_REPORT_WINDOW_TAB,
                            data:tab
                        });
                    }
                } else {
                    respond('Im not getting where should i take you');
                }
            }
        },
    ];


    onSpeechResult =results=> {
        let finalScript = results[results.length-1].transcript;
    };
    getAction = () => {
        switch(this.action) {
            case 'output1_enable':
                return "Output 1 Enable"
                break
            case 'output2_enable':
                return "Output 2 Enable"
                break    
            case 'output1_disable':
                return "Output 1 Disable"
                break    
            case 'output2_disable':
                return "Output 2 Disable"
                break        
        }
    }

    setMqttRef = (ref) => {
        this.mqttRef = ref;
      };

    render() {
        let tab = this.props.reportWindow.tab ? this.props.reportWindow.tab.key:''
        let immobilize_type = _.get(this.selectedVehicle, 'vehiclemeta.immobilize_type');
        let devicetype = _.get(this.selectedVehicle, 'devices.TRACKER.devicetype')
        return (
            <div className={"InMap inWidgetContainer" + (this.isTableViewActive() ? ' tableView' : '')} id="mapCanvas">
                {/*<InVoice onResult={this.onSpeechResult} commands={this.commands} ref="voice"/>*/}
                <div className={"im-tableView" + (this.isTableViewActive() ? ' active' : '')}>
                    <InTable saveState={this.saveTableViewState}
                             schemaKey={this.getTableViewKey()}
                             resume={this.getTableViewResumeData()}
                             ref="tableView"
                             data={this.getTableViewConfig()}/>
                </div>
                {
                    (!window.graphControlData && this.props.reportWindow.visible) || (this.props.reportWindow.visible && tab == "can_data_dump_report") || (this.props.reportWindow.visible && tab == "geofence_report") ? (
                        <div className="im-disable">{window.graphDataErr}</div>
                    ) : ''
                }
                <div></div>
                <Map ref={map=>this.map = map} listeners={this.getMapListeners()}></Map>
                <MQTT host={MQTT_HOST} onload={this.MQTTLoaded} auth={this.props.auth} onReceiveMessage={this.onReceivedMessage} ref={this.setMqttRef} />
                <CallbackBuddy if={this.getVehicleMap()} then={this.gotVehicleMap}/>
                <CallbackBuddy if={this.props.roadStats} onDataChange={this.roadStatsChanged}/>
                <CallbackBuddy if={this.props.reportWindow} onDataChange={this.reportWindowChanged}/>
                <CallbackBuddy if={this.props.statsFilter} onDataChange={this.statsFilterChanged}/>
                <CallbackBuddy if={this.props.searchString} onDataChange={this.singleSearch}/>
                <CallbackBuddy if={this.props.geofenceMap} onDataChange={this.geofenceChanged}/>
                <CallbackBuddy if={this.props.geofenceFilters} onDataChange={this.geofenceFiltersChanged}/>
                <CallbackBuddy if={this.props.overlayFilters} onDataChange={this.overlayFiltersChanged}/>
                <CallbackBuddy if={this.props.tableView} onDataChange={this.tableViewChanged}/>
                <CallbackBuddy if={this.props.lastLoc} onDataChange={this.lastLocChanged}/>
                <InPopup height={330} width={600} visiblity={this.state.immobWindowVisiblity} title={this.lastImmobState === 0 ? "Immobilize" : 'Mobilize'}  onClose={this.onImmobWindowClose}>
                    <div className="in-imm-window">
                        <table>
                            <tbody>
                            <tr><td>Vehicle No: </td><td> {this.selectedVehicle ? this.selectedVehicle.vehicleno : 'Unknown vehicle'} </td></tr>
                            <tr><td>Device ID: </td><td> {this.selectedVehicle && this.selectedVehicle.devices.TRACKER ? this.selectedVehicle.devices.TRACKER.deviceno : 'Unknown device'} </td></tr>
                            </tbody>
                        </table>
                            {
                                this.lastImmobState === 0 &&
                                devicetype === "laf" && immobilize_type === 'ignition' ?
                                (<div className="in-imm-btnset">
                                    <div onClick={()=>this.openImmobilizeWindow('IGNITION')} className={Dom.Class({'inactive':!this.canIImmobilize('IGNITION')}, "in-imm-btn")}>Immobilize On Stop</div>
                                    {window.userInfo && window.userInfo.SELF && window.userInfo.SELF.enable_immediate_immob ? <div onClick={()=>this.openImmobilizeWindow('IMMEDIATE')} className={Dom.Class({'inactive':!this.canIImmobilize('IMMEDIATE')}, "in-imm-btn")}>Immobilize Immediately</div>: null}
                                </div>) :
                                this.lastImmobState === 0 &&
                                immobilize_type === "direct_to_output" ? 
                                (<div className="output-btset">
                                    <div className="output-set1">
                                        <div onClick={()=>this.openImmobilizeWindow('direct_to_output','output1_enable')} className={Dom.Class({'inactive':!this.canIImmobilize('direct_to_output')}, "in-imm-btn1")}>Output 1 Enable</div>
                                        <div onClick={()=>this.openImmobilizeWindow('direct_to_output', 'output2_enable')} className={Dom.Class({'inactive':!this.canIImmobilize('direct_to_output')}, "in-imm-btn1")}>Output 2 Enable</div>
                                   </div>
                                   <div className="output-set2">
                                        <div onClick={()=>this.openImmobilizeWindow('direct_to_output', 'output1_disable')} className={Dom.Class({'inactive':!this.canIImmobilize('')}, "in-imm-btn2")}>Output 1 Disable</div>
                                        <div onClick={()=>this.openImmobilizeWindow('direct_to_output', 'output2_disable')} className={Dom.Class({'inactive':!this.canIImmobilize('')}, "in-imm-btn2")}>Output 2 Disable</div>
                                    </div>
                                </div>) :
                                this.lastImmobState === 0 ? (
                                    <div className="in-imm-btnset">
                                        {immobilize_type === 'can' && <div onClick={()=>this.openImmobilizeWindow('CAN')} className={Dom.Class({'inactive':!this.canIImmobilize('CAN')}, "in-imm-btn")}>CAN Immobilize</div>}
                                        {immobilize_type !== 'ignition' && <div onClick={()=>this.openImmobilizeWindow('CRANK')} className={Dom.Class({'inactive':!this.canIImmobilize('CRANK')}, "in-imm-btn")}>Crank Immobilize</div>}
                                        {immobilize_type !== 'crank' && <div onClick={()=>this.openImmobilizeWindow('IGNITION')} className={Dom.Class({'inactive':!this.canIImmobilize('IGNITION')}, "in-imm-btn")}>Ignition Immobilize</div>}
                                    </div>
                                ) : (
                                    <div className="in-imm-btnset">
                                        {immobilize_type !== 'crank' && <div onClick={()=>this.openImmobilizeWindow('CRANK')} className={Dom.Class({'inactive':!this.canIImmobilize('CRANK')}, "in-imm-btn --green")}>Crank Mobilize</div>}
                                        {immobilize_type !== 'crank' && <div onClick={()=>this.openImmobilizeWindow('IGNITION')} className={Dom.Class({'inactive':!this.canIImmobilize('IGNITION')}, "in-imm-btn --green")}>Ignition Mobilize</div>}
                                    </div>
                                )
                            }
                        {!immobilize_type === "direct_to_output" ?<div className="in-imm-content">
                            * Ignition Immobilize option will be enabled after Crank Immobilize is successful<br/>
                            * Ignition Immobilize usually takes 2 to 3 minutes if the vehicle is in Ignition ON state<br/>
                            * If the vehicle is in ignition OFF state. Immobilization will not happen immediately<br/>
                            * For a vehicle in ignition OFF state, any Immobilization command sent will be delivered after 30 minutes<br/>
                            * On Realtime Vehicle status dial<br/>
                            ------ Yellow = Vehicle is Crank Immobilized<br/>
                            ------ Red = Vehicle is Ignition Immobilized<br/>
                        </div>  :null}
                    </div>
                </InPopup>
                <InPopup height={200} width={400} visiblity={this.state.immobCWindowVisiblity} title={immobilize_type === "direct_to_output" ? this.getAction() : this.lastImmobState === 0 ? "Immobilize" : 'Mobilize'} onClose={this.onImmobCWindowClose}>
                    <div className="in-imm-window">
                        <table>
                            <tbody>
                            <tr><td>Vehicle No: </td><td> {this.selectedVehicle ? this.selectedVehicle.vehicleno : 'Unknown vehicle'} </td></tr>
                            <tr><td>Device ID: </td><td> {this.selectedVehicle && this.selectedVehicle.devices.TRACKER ? this.selectedVehicle.devices.TRACKER.deviceno : 'Unknown device'} </td></tr>
                            </tbody>
                        </table>
                        <div className="in-imm-btnset">
                            {
                                this.lastImmobState === 0 ? (
                                    <div onClick={()=>this.immobilize()} className="in-imm-btn">{immobilize_type === "direct_to_output" ? "Send" : "Immobilize"} </div>
                                ) : (
                                    <div onClick={()=>this.immobilize()} className="in-imm-btn --green">Mobilize</div>
                                )
                            }
                            <div onClick={()=>this.onImmobCWindowClose()} className="in-imm-btn">Cancel</div>
                        </div>
                    </div>
                </InPopup>

                <InPopup height={200} width={400} visiblity={this.state.lockWindowVisiblity} title={this.lastLockState === 0 ? "Lock" : 'Unlock'} onClose={this.onLockWindowClose}>
                    <div className="in-imm-window">
                        <table>
                            <tbody>
                            <tr><td>Vehicle No: </td><td> {this.selectedVehicle ? this.selectedVehicle.vehicleno : 'Unknown vehicle'} </td></tr>
                            <tr><td>Device ID: </td><td> {this.selectedVehicle && this.selectedVehicle.devices.TRACKER ? this.selectedVehicle.devices.TRACKER.deviceno : 'Unknown device'} </td></tr>
                            </tbody>
                        </table>
                        <div className="in-imm-btnset">
                            {
                                this.lastLockState === 0 ? (
                                    <div onClick={()=>this.lock()} className="in-imm-btn">Lock</div>
                                ) : (
                                    <div onClick={()=>this.lock()} className="in-imm-btn --green">Unlock</div>
                                )
                            }
                            <div onClick={()=>this.onImmobCWindowClose()} className="in-imm-btn">Cancel</div>
                        </div>
                    </div>
                </InPopup>

                <ForwardedInGraph data={this.graphHandlerData} config={{type:'graph', height:49, width:399}} ref={this.graphHandlerRef}/>
                {this.state.shareLink ? <SharePopup selectedVehicle = {this.selectedVehicle} closeLocShare= {() =>this.closeLocShare()}/> : null}
            </div>
        )
    }

}

const MapPropsToState = (state) => {
    return {
        auth: state.auth,
        vehicleMap: state.vehicleMap,
        roadStats:state.roadStats,
        reportWindow:state.reportWindow,
        statsFilter: state.statsFilter,
        searchString: state.searchString,
        geofenceMap: state.geofenceMap,
        geofenceFilters: state.geofenceFilters,
        overlayFilters: state.overlayFilters,
        tableView: state.tableView,
        freezMap:state.freezMap,
        allowedVehicles: state.allowedVehicles,
        DGeofence: state.DGeofence,
        groupTree: state.groupTree,
        lastLoc: state.lastLoc,
        muteAudio: state.muteAudio,
    }
};

export default connect(MapPropsToState)(InMap);

